import React from 'react';

import Home from './Home';

const HomepageContainer = props => <Home {...props} />;

export default HomepageContainer;
